import { LogSelectionOption } from '~/shared/utils/types';

export function calculatePercentageChange(previousValue: number, currentValue: number): number {
  if (previousValue === 0) {
    return 0;
  }
  return Math.round(((currentValue - previousValue) / previousValue) * 100);
}

export function isNegative(number: number) {
  return number < 0;
}

export function makePositive(number: number) {
  return Math.abs(number);
}

export function getApiFilterFromSelectOption(f: LogSelectionOption) {
  return JSON.stringify({
    field: f.group,
    value: f.id,
    op: 'equals',
  });
}
